import React from "react"
import InfiniteScroll from "react-infinite-scroll-component"

import { InfiniteScrollLoading } from "components"
import StrTableRow from "./StrTableRow"
import classes from "./StrTable.module.scss"

const StrTable = (props) => {
  const {
    hasMore,
    skip,
    loadMore,
    stockTransferRequests,
    setStockTransferRequests
  } = props

  return (
    <div
      id="scrollable-div"
      className={classes["table-container"]}
    >
      <InfiniteScroll
        hasMore={hasMore}
        dataLength={skip}
        next={loadMore}
        style={{ overflow: "unset" }}
        scrollableTarget="scrollable-div"
        loader={<InfiniteScrollLoading />}
        scrollThreshold="100px"
      >
        <table className={classes["table"]}>
          <thead>
            <tr>
              <th style={{ width: "0%" }}>شماره سند</th>
              <th>تاریخ ایجاد درخواست</th>
              <th>شعبه درخواست داده</th>
              <th>شعبه درخواست شده</th>
              <th>وضعیت درخواست</th>
              <th>تاریخ شروع ارسال</th>
              <th>تاریخ دریافت محموله</th>
              <th>جزئیات</th>
            </tr>
          </thead>
          <tbody>
            {stockTransferRequests.map((stockTransferRequest) =>
              <StrTableRow
                key={stockTransferRequest._id}
                stockTransferRequest={stockTransferRequest}
                setStockTransferRequests={setStockTransferRequests}
              />
            )}
          </tbody>
        </table>
      </InfiniteScroll>
    </div>
  )
}

export default StrTable